document.addEventListener("DOMContentLoaded", () => {
  const INSURANCE_VARIANT_IDS = {
    500: "45603252174999",
    1000: "45603252207767",
    1500: "45603252240535",
    2000: "45603252273303",
    2500: "45603252306071",
    3000: "45603252338839",
    3500: "45603252371607",
    4000: "45603252404375",
    4500: "45603252437143",
    5000: "45603252469911",
    5500: "45603252502679",
    6000: "45603252535447",
    6500: "45603252568215",
    7000: "45603252600983",
    7500: "45603252633751",
    8000: "45528735350935",
    8500: "45528735383703",
    9000: "45528735416471",
    9500: "45528735482007",
    10000: "45528735514775",
    11000: "45528735547543",
    12000: "45528735613079",
    13000: "45528735678615",
    14000: "45528735711383",
    15000: "45528735776919",
    16000: "45528735809687",
    17000: "45528735875223",
    18000: "45528735907991",
    19000: "45633534591127",
    20000: "45633534623895",
  };

  const currencyCode = window.Shopify?.currency?.active || 'USD';
  const currencyRate = window.Shopify?.currency?.rate || 1;

  const getCart = () => fetch("/cart.js").then((res) => res.json());

  const determineVariantId = (total_price) => {
    const price = total_price / 100 / currencyRate; // 转为 USD 基准
    const tiers = Object.keys(INSURANCE_VARIANT_IDS)
      .map(Number)
      .sort((a, b) => a - b);
    for (let i = 0; i < tiers.length; i++) {
      if (price <= tiers[i]) return INSURANCE_VARIANT_IDS[tiers[i]];
    }
    return null;
  };

  const removeAllInsuranceVariants = async (cart) => {
    const variantIds = Object.values(INSURANCE_VARIANT_IDS);
    const removals = cart.items
      .filter((item) => variantIds.includes(item.variant_id.toString()))
      .map((item) =>
        fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: item.key, quantity: 0 }),
        })
      );
    await Promise.all(removals);
  };

  const updateInsuranceLabel = (price) => {
    const labelEl = document.querySelector(
      'label[for="add-insurance-checkbox"] strong'
    );
    if (labelEl) {
      const estimatedFee = price * 0.02;

      const formatted = new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: 2,
      }).format(estimatedFee);

      labelEl.textContent = `Add Shipping Insurance (2%) ≈ ${formatted}`;
    }
  };

  let isProcessing = false;
  const setupCheckbox = async () => {
    const checkbox = document.getElementById("add-insurance-checkbox");
    if (!checkbox || isProcessing) return;

    checkbox.disabled = true;

    try {
      const cart = await getCart();
      const currentId = determineVariantId(cart.total_price);
      const variantIds = Object.values(INSURANCE_VARIANT_IDS);
      const matchedItem = cart.items.find((item) =>
        variantIds.includes(item.variant_id.toString())
      );

      checkbox.checked = matchedItem?.variant_id.toString() === currentId;
      updateInsuranceLabel(cart.total_price / 100);

      if (!checkbox.hasSetup) {
        checkbox.addEventListener("change", async () => {
          if (isProcessing) return;
          isProcessing = true;
          checkbox.disabled = true;

          try {
            const updatedCart = await getCart();
            const newVariantId = determineVariantId(updatedCart.total_price);
            await removeAllInsuranceVariants(updatedCart);

            if (checkbox.checked && newVariantId) {
              const res = await fetch("/cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id: newVariantId, quantity: 1 }),
              });

              if (!res.ok) throw new Error("Add insurance failed");
            }

            document.dispatchEvent(
              new CustomEvent("cart:refresh", { detail: { open: true } })
            );
          } catch (err) {
            console.error("Insurance update error:", err);
            checkbox.checked = false;
          } finally {
            checkbox.disabled = false;
            isProcessing = false;
          }
        });
        checkbox.hasSetup = true;
      }

      checkbox.disabled = false;
    } catch (err) {
      console.error("Cart load error:", err);
      checkbox.disabled = false;
    }
  };

  const throttle = (fn, delay) => {
    let timer;
    return (...args) => {
      if (!timer) {
        timer = setTimeout(() => {
          fn(...args);
          timer = null;
        }, delay);
      }
    };
  };

  const observer = new MutationObserver(throttle(setupCheckbox, 300));
  observer.observe(document.body, { childList: true, subtree: true });

  document.addEventListener("cart:updated", () => {
    setupCheckbox();
  });

  setupCheckbox();
});